import {DateBaseAttribute, DateBaseAttributeOptions} from './DateBaseAttribute';

export type DateTimeSecondsAttributeOptions = DateBaseAttributeOptions;

export class DateTimeSecondsAttribute extends DateBaseAttribute {
  constructor(options: DateTimeSecondsAttributeOptions = {}) {
    super(options);
  }

  get inputType(): string {
    return 'datetime-seconds';
  }
}
